import { AnalyticsProvider, useAnalyticsContext } from '@bbld/bbl-analytics'
import history from 'browserHistory'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { IBBL } from 'shared/models/BBL'
import { getActiveClient } from 'shared/store/clients/selectors'

interface IProps {
  bbl: IBBL
  children?: React.ReactNode
}

const DataLayerSync: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const analytics = useAnalyticsContext()
  const activeClient = useSelector(getActiveClient)

  useEffect(() => {
    analytics.setDataLayerVariables({
      customer: activeClient?.clientName ?? '',
    })
  }, [activeClient?.clientName, analytics])

  return <>{children}</>
}

const AnalyticsHandler: FC<IProps> = ({ bbl, children }) => {
  const analyticsSettings = {
    gtmCodes: [window.config.bblPivotalGtmCode],
    siteName: window.config.appName,
    bblCode: window.config.bblCode,
    ngtApp: Boolean(window.ReactNativeWebView),
  }
  if (bbl.settings.gtmId) {
    analyticsSettings.gtmCodes.push('GTM-' + bbl.settings.gtmId)
  }

  return (
    <AnalyticsProvider settings={analyticsSettings} history={history}>
      <DataLayerSync>{children}</DataLayerSync>
    </AnalyticsProvider>
  )
}

export default AnalyticsHandler
